module.exports = __webpack_public_path__ + "media/images/official/guide_image1-2883f6a8d6e8cd19709af7190d18a389.svg";